import * as React from "react";
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const location = useLocation();

    const { userType } = useAppSelector((s) => s.auth);
    const isManagement = userType?.toLowerCase().includes("management");
    const isAdmin = userType?.toLowerCase().includes("admin");

    if (!isAuthenticated) {
        const path = isManagement ? "/management_login" : isAdmin? "admin_login" : "/login";
        return <Navigate to={path} state={{ from: location }} replace />;
    }


    return children;
};

export default PrivateRoute;
